function LandingPage() {
    (() => {
        window.location.replace('https://sumup.com');
    })();

    return null;
}

export default LandingPage;
